const bannerConfig = {
    popup: {
        listLayout: 'BannerListPopupLayout',
        getFunc: 'getPopupBanner',
        listApiParamSet: {
        },
        deleteFunc: 'deletePopupBanner',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
        },
        keyName: 'pu_idx',
    },

    levelMain: {
        listLayout: 'BannerListImageLayout',
        getFunc: 'getBanner',
        listApiParamSet: {
            ity : 'level_banner'
        },
        a_container_type: 'level_banner',
        a_container_id: 1,
        imageWidth: 640,
        imageHeight: 160,
        uploadClass: 'level-banner',
    },
    liveclass: {
        listLayout: 'BannerListImageLayout',
        getFunc: 'getBanner',
        listApiParamSet: {
            ity : 'level_live_klass'
        },
        a_container_type: 'level_live_klass',
        a_container_id: 1,
        imageWidth: 640,
        imageHeight: 160,
        uploadClass: 'level-banner',
    },
    chat: {
        listLayout: 'BannerListImageLayout',
        getFunc: 'getBanner',
        listApiParamSet: {
            ity : 'chat'
        },
        a_container_type: 'chat',
        a_container_id: 1,
        imageWidth: 640,
        imageHeight: 160,
        uploadClass: 'level-banner',
    },
    freeTalking: {
        listLayout: 'BannerListImageLayout',
        getFunc: 'getBanner',
        listApiParamSet: {
            ity : 'free_talking'
        },
        a_container_type: 'free_talking',
        a_container_id: 1,
        imageWidth: 640,
        imageHeight: 160,
        uploadClass: 'level-banner',
    },
    koreanSpeaking: {
        listLayout: 'BannerListImageLayout',
        getFunc: 'getBanner',
        listApiParamSet: {
            ity : 'speak_korean'
        },
        a_container_type: 'speak_korean',
        a_container_id: 1,
        imageWidth: 640,
        imageHeight: 160,
        uploadClass: 'level-banner',
    },
    popupCreate:{
        writeLayouts: ['BannerWritePopupLayout'],
        getFunc: '',
        detailApiParamsSet: {
        },
        writeFunc: 'createPopupBanner',
        writeApiParamSet: {
        },
        parsingData: {
            linkType :'pu_linked_type',
            display :'pu_is_display',
            linkUrl :'pu_linked_url',
            linkBoardKey :'pu_linked_idx',
            seq :'pu_seq'
        },
        directUrl: '',
        directType: 'modalClose',
        keyName: 'idx',
        closeModalName : 'popup-banner-create-modal',
        writeSuccessType: 1,
        writeFailTypes: {
            '-1': "수정 실패했습니다.",
            '-100':"필수값을 확인해주세요.",
            '-254':"노출가능한 팝업은 10개를 초과할 수 없습니다.",
            '-99':"진행중이지않은 이벤트입니다.",
            '-101' : "존재하지 않는 게시물입니다.",
        },
        fileType: 'popup',
    },
    popupUpdate:{
        writeLayouts: ['BannerWritePopupLayout'],
        getFunc: 'getPopupBanner',
        detailApiParamsSet: {
        },
        writeFunc: 'updatePopupBanner',
        writeApiParamSet: {
        },
        parsingData: {
            linkType :'pu_linked_type',
            display :'pu_is_display',
            linkUrl :'pu_linked_url',
            linkBoardKey :'pu_linked_idx',
            seq :'pu_seq'
        },
        directUrl: '',
        directType: 'modalClose',
        closeModalName : 'popup-banner-update-modal',
        keyName: 'idx',
        writeSuccessType: 1,
        writeFailTypes: {
            '-1': "수정 실패했습니다.",
            '-102':"잘못된 게시글을 선택했습니다.",
            '-100' : "필수 값을 확인해주세요.",
            '-254':"노출가능한 팝업은 10개를 초과할 수 없습니다.",
            '-99':"진행중이지않은 이벤트입니다.",
            '-101' : "존재하지 않는 게시물입니다.",
        },
        fileType: 'popup',
    },
    levelMainUpdate: {
        writeLayouts: ['BannerWriteImageLayout'],
        getFunc: 'getBanner',
        detailApiParamsSet: {
            ity : 'level_banner'
        },
        writeFunc: 'updateBanner',
        writeApiParamSet: {
            b_seq: 1,
        },
        parsingData: {
            linkType :'b_type',
            linkImageUrl :'b_url',
            linkImageBoardKey :'b_key',
        },
        writeKeyName: 'b_idx',
        directUrl: '',
        directType: 'modalClose',
        closeModalName : 'image-banner-update-modal',
        keyName: 'idx',
        writeSuccessType: 1,
        writeFailTypes: {
            '-1': "수정 실패했습니다.",
            '-102':"잘못된 게시글을 선택했습니다.",
            '-100' : "필수 값을 확인해주세요.",
            '-254':"노출가능한 팝업은 10개를 초과할 수 없습니다.",
            '-99':"진행중이지않은 이벤트입니다.",
            '-101' : "존재하지 않는 게시물입니다.",
        },
        fileType: 'level_banner',
    },
    liveclassUpdate: {
        writeLayouts: ['BannerWriteImageLayout'],
        getFunc: 'getBanner',
        detailApiParamsSet: {
            ity : 'level_live_klass'
        },
        writeFunc: 'updateBanner',
        writeApiParamSet: {
            b_seq: 1,
        },
        parsingData: {
            linkType :'b_type',
            linkImageUrl :'b_url',
            linkImageBoardKey :'b_key',
        },
        writeKeyName: 'b_idx',
        directUrl: '',
        directType: 'modalClose',
        closeModalName : 'image-banner-update-modal',
        keyName: 'idx',
        writeSuccessType: 1,
        writeFailTypes: {
            '-1': "수정 실패했습니다.",
            '-102':"잘못된 게시글을 선택했습니다.",
            '-100' : "필수 값을 확인해주세요.",
            '-254':"노출가능한 팝업은 10개를 초과할 수 없습니다.",
            '-99':"진행중이지않은 이벤트입니다.",
            '-101' : "존재하지 않는 게시물입니다.",
        },
        fileType: 'level_live_klass',
    },
    chatUpdate: {
        writeLayouts: ['BannerWriteImageLayout'],
        getFunc: 'getBanner',
        detailApiParamsSet: {
            ity : 'chat'
        },
        writeFunc: 'updateBanner',
        writeApiParamSet: {
            b_seq: 1,
        },
        parsingData: {
            linkType :'b_type',
            linkImageUrl :'b_url',
            linkImageBoardKey :'b_key',
        },
        writeKeyName: 'b_idx',
        directUrl: '',
        directType: 'modalClose',
        closeModalName : 'image-banner-update-modal',
        keyName: 'idx',
        writeSuccessType: 1,
        writeFailTypes: {
            '-1': "수정 실패했습니다.",
            '-102':"잘못된 게시글을 선택했습니다.",
            '-100' : "필수 값을 확인해주세요.",
            '-254':"노출가능한 팝업은 10개를 초과할 수 없습니다.",
            '-99':"진행중이지않은 이벤트입니다.",
            '-101' : "존재하지 않는 게시물입니다.",
        },
        fileType: 'chat',
    },

    freeTalkingUpdate: {
        writeLayouts: ['BannerWriteImageLayout'],
        getFunc: 'getBanner',
        detailApiParamsSet: {
            ity : 'free_talking'
        },
        writeFunc: 'updateBanner',
        writeApiParamSet: {
            b_seq: 1,
        },
        parsingData: {
            linkType :'b_type',
            linkImageUrl :'b_url',
            linkImageBoardKey :'b_key',
        },
        writeKeyName: 'b_idx',
        directUrl: '',
        directType: 'modalClose',
        closeModalName : 'image-banner-update-modal',
        keyName: 'idx',
        writeSuccessType: 1,
        writeFailTypes: {
            '-1': "수정 실패했습니다.",
            '-102':"잘못된 게시글을 선택했습니다.",
            '-100' : "필수 값을 확인해주세요.",
            '-254':"노출가능한 팝업은 10개를 초과할 수 없습니다.",
            '-99':"진행중이지않은 이벤트입니다.",
            '-101' : "존재하지 않는 게시물입니다.",
        },
        fileType: 'free_talking',
    },
    koreanSpeakingUpdate: {
        writeLayouts: ['BannerWriteImageLayout'],
        getFunc: 'getBanner',
        detailApiParamsSet: {
            ity : 'speak_korean'
        },
        writeFunc: 'updateBanner',
        writeApiParamSet: {
            b_seq: 1,
        },
        parsingData: {
            linkType :'b_type',
            linkImageUrl :'b_url',
            linkImageBoardKey :'b_key',
        },
        writeKeyName: 'b_idx',
        directUrl: '',
        directType: 'modalClose',
        closeModalName : 'image-banner-update-modal',
        keyName: 'idx',
        writeSuccessType: 1,
        writeFailTypes: {
            '-1': "수정 실패했습니다.",
            '-102':"잘못된 게시글을 선택했습니다.",
            '-100' : "필수 값을 확인해주세요.",
            '-254':"노출가능한 팝업은 10개를 초과할 수 없습니다.",
            '-99':"진행중이지않은 이벤트입니다.",
            '-101' : "존재하지 않는 게시물입니다.",
        },
        fileType: 'speak_korean',
    },


}
export default {
    methods: {
        returnBannerConfig(type) {
            return bannerConfig[type];
        }
    },
    filterConfig: {
    }
}
